import React from 'react';
import { SUPPORT } from '../../config';

/**
 * Represents a help message to dispay when login issue
 * Properties: error, onValidAuth(user, pasw)
 */
export function ResetPasswordMsg() {
    return (
        <div className="w3-small">
            You can easily get an error when the session has expired (so please make sure you <em>log out</em> when
            you have finished your work).<br /><br />
            Please <a className="link" onClick={() => window.location.reload()}>refresh</a> <kbd>F5</kbd> the page
            first. You can also <em>reset your password</em> by entering your e-mail address. If the problem persists,
            please contact the <a href={`mailto:${SUPPORT}`} rel="noreferrer">Auditum or Prodatec support</a>.
        </div>
    );
}
